// src/pages/TokensPage.jsx
import React, { useState, useEffect } from 'react';

// ===== CHARTJS =====
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ArcElement,
  Tooltip,
  Legend,
  Title
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ArcElement,
  Tooltip,
  Legend,
  Title
);

import { Line, Doughnut } from 'react-chartjs-2';

// ===== SWIPER PARA CARRUSELES =====
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

// ===== ICONOS =====
import {
  FaRocket,
  FaChartLine,
  FaCoins,
  FaShieldAlt,
  FaQrcode,
  FaLock,
  FaVoteYea,
  FaNetworkWired,
  FaHandHoldingUsd,
  FaCube,
  FaLink,
  FaGlobe,
  FaMobile,
  FaDatabase,
  FaCodeBranch
} from 'react-icons/fa';

// ===== ESTILOS E IMAGEN =====
import '../styles/TokensPage.css';
import logoImage from '../Assets/logo_moneda.png';
import videoLogo from '../Assets/video_logos.mp4';


const TokensPage = () => {
  const [activeTab, setActiveTab] = useState('about');
  const [isMobile, setIsMobile] = useState(false);
  const [priceData, setPriceData] = useState(null);

  // DETECTAR MÓVIL
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // DATOS SIMULADOS
  useEffect(() => {
    const mockPriceData = {
      currentPrice: 0.004,
      change24h: 0.004,
      marketCap: 3460,
      volume24h: 125000,
      circulatingSupply: 8750000,
      totalSupply: 21000000
    };
    setPriceData(mockPriceData);
  }, []);

  // DATOS GRÁFICO PRECIO
  const priceChartData = {
    labels: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
    datasets: [
      {
        label: 'Precio BGP (EUR)',
        data: [0, 0, 1, 1, 1, 1.1, 0.004, 0.004, 0.004, 0.004, 0.004, 0.004],
        borderColor: '#ffcc00',
        backgroundColor: 'rgba(255, 204, 0, 0.1)',
        borderWidth: 3,
        tension: 0.4,
        fill: true,
        pointBackgroundColor: '#ffcc00',
        pointBorderColor: '#000',
        pointBorderWidth: 2,
        pointRadius: 4,
        pointHoverRadius: 8
      },
    ],
  };

  // DATOS DISTRIBUCIÓN
  const distributionData = {
    labels: ['Ventas', 'Equipo', 'Desarrollo', 'Marketing', 'Reserva'],
    datasets: [
      {
        data: [60, 15, 10, 10, 5],
        backgroundColor: [
          '#ffcc00',
          '#60a5fa',
          '#10b981',
          '#8b5cf6',
          '#ef4444'
        ],
        borderWidth: 0,
        borderRadius: 8
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: '#000',
        titleColor: '#ffcc00',
        bodyColor: '#fff',
        borderColor: '#ffcc00',
        borderWidth: 2,
        padding: 12,
        cornerRadius: 8
      }
    },
    scales: {
      y: {
        grid: { color: 'rgba(255, 204, 0, 0.1)' },
        ticks: { color: '#94a3b8' }
      },
      x: {
        grid: { display: false },
        ticks: { color: '#94a3b8' }
      }
    }
  };

  // WHITE PAPER CARDS PARA CARRUSEL
  const wpCards = [
    {
      icon: '📋',
      title: 'Resumen Ejecutivo',
      content: 'Bitcoin Global Pay (BGP) es un token desarrollado sobre Solana, diseñado como solución rápida y escalable para plataformas, DeFi y trazabilidad de productos físicos mediante NFTs y NFC.',
      highlight: 'BGP conecta el mundo físico y digital permitiendo a empresas y particulares codificar productos y acceder a servicios financieros descentralizados.'
    },
    {
      icon: '⚠️',
      title: 'Problema que Resuelve',
      list: [
        'Falta de trazabilidad real de productos',
        'Procesos lentos y costosos para codificaciones',
        'Escasa interoperabilidad NFTs-productos',
        'Sistemas de transacciones con altas comisiones'
      ]
    },
    {
      icon: '💡',
      title: 'Solución Propuesta',
      pillars: ['NFTs + NFC', 'Servicios de codificicaión', 'Sistema de transacciones']
    },
    {
      icon: '⚙️',
      title: 'Arquitectura Técnica',
      tech: ['Solana', 'SPL Token', 'Metaplex', 'NFC']
    },
    {
      icon: '🗳️',
      title: 'Gobernanza',
      content: 'Modelo descentralizado donde el token  de BGP servirá para codificar NFC con NFTS.'
    },
    {
      icon: '🔒',
      title: 'Seguridad',
      list: [
        'Smart contracts auditables',
        'Custodia descentralizada',
        'Transparencia on-chain'
      ]
    }
  ];

  // FEATURES COMPLETAS
  const features = [
    {
      icon: <FaQrcode />,
      title: 'NFTs + NFC',
      description: 'Trazabilidad verificable de productos físicos mediante chips NFC vinculados a NFTs únicos en Solana.'
    },

    {
      icon: <FaRocket />,
      title: 'Red Solana',
      description: 'Token SPL en Solana: bajos costes, alta velocidad y escalabilidad infinita.'
    },
    {
      icon: <FaNetworkWired />,
      title: 'Trazabilidad Total',
      description: 'Blockchain como capa de confianza para verificar origen, autenticidad y cadena de custodia.'
    },

  ];

  // CASOS DE USO PARA CARRUSEL
  const useCases = [
    {
      number: '01',
      icon: <FaQrcode />,
      title: 'NFTs + NFC',
      subtitle: 'Trazabilidad de productos físicos',
      details: [
        'Características del producto',
        'Origen y fabricante',
        'Historial de propiedad',
        'Verificación de autenticidad'
      ],
      badge: '✅ Combate falsificaciones · Transparencia total'
    }
  ];

  // ROADMAP PARA CARRUSEL
  const roadmapPhases = [
    {
      phase: 'Fase 1',
      title: 'Fundación',
      items: [
        { text: 'Creación del token BGP', status: 'completed' },
        { text: 'Lanzamiento inicial', status: 'completed' }
      ]
    },
    {
      phase: 'Fase 2',
      title: 'Global',
      items: [
        { text: 'Expansión global', status: 'pending' },
        { text: 'Alianzas empresariales', status: 'pending' }
      ]
    },
    {
      phase: 'Fase 3',
      title: 'Integración',
      items: [
        { text: 'NFTs + NFC', status: 'in-progress' },
      ]
    }


  ];

  // STATS PARA CARRUSEL
  const statsCards = priceData ? [
    {
      value: `€${priceData.currentPrice.toFixed(2)}`,
      label: 'Precio Actual',
      change: priceData.change24h,
      isMain: true
    },
    {
      value: `€${priceData.marketCap.toFixed(2)}`,
      label: 'Market Cap'
    },
    {
      value: '21M',
      label: 'Suministro Total'
    }
  ] : [];

  return (
    <div className="tokens-page">

   {/* ===== HERO SECTION ===== */}
<section className="tokens-hero">
  <div className="hero-content">
    <div className="token-logo-container">
      <div className="token-logo-wrapper">
        <video
          className="token-video-round"
          autoPlay
          loop
          muted
          playsInline
          src="/Assets/video_logos.mp4"
        />
        <div className="token-glow"></div>
      </div>
      
      {/* AÑADIMOS MÁS SEPARACIÓN AQUÍ - Clase nueva para el título */}
      <div className="token-title-wrapper with-separation">
        <h1 className="token-title">
          <span className="title-line">Bitcoin</span>
          <span className="title-line">Global Pay</span>
        </h1>
        <div className="token-symbol-badge">BGP</div>
      </div>
    </div>
    
    <p className="hero-description">
      Conectando el mundo físico y digital
    </p>
    
    <div className="hero-tags">
      <span className="hero-tag">Solana</span>
      <span className="hero-tag">SPL Token</span>
      <span className="hero-tag">Metaplex</span>
      <span className="hero-tag">NFC</span>
    </div>
    
    <div className="hero-stats-mini">
      <div className="mini-stat">
        <span className="mini-stat-label">Suministro</span>
        <span className="mini-stat-value">21M BGP</span>
      </div>
      <div className="mini-stat-divider"></div>
      <div className="mini-stat">
        <span className="mini-stat-label">Red</span>
        <span className="mini-stat-value">Solana</span>
      </div>
    </div>
  </div>
</section>

      {/* ===== STATS SECTION CON CARRUSEL EN MÓVIL ===== */}
      {priceData && (
        <section className="stats-section">
          <div className="stats-container">
            {isMobile ? (
              <Swiper
                modules={[Pagination, Autoplay]}
                spaceBetween={16}
                slidesPerView={1.2}
                centeredSlides={true}
                pagination={{
                  clickable: true,
                  dynamicBullets: true
                }}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false
                }}
                loop={true}
                className="stats-carousel"
              >
                {statsCards.map((stat, index) => (
                  <SwiperSlide key={index}>
                    <div className={`stat-card-mobile ${stat.isMain ? 'main' : ''}`}>
                      <div className="stat-value">{stat.value}</div>
                      <div className="stat-label">{stat.label}</div>
                      {stat.change && (
                        <div className={`price-change ${stat.change >= 0 ? 'positive' : 'negative'}`}>
                          {stat.change >= 0 ? '↗' : '↘'} {Math.abs(stat.change)}%
                        </div>
                      )}
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            ) : (
              <div className="stats-grid">
                {statsCards.map((stat, index) => (
                  <div key={index} className={`stat-card ${stat.isMain ? 'main' : ''}`}>
                    <div className="stat-value">{stat.value}</div>
                    <div className="stat-label">{stat.label}</div>
                    {stat.change && (
                      <div className={`price-change ${stat.change >= 0 ? 'positive' : 'negative'}`}>
                        {stat.change >= 0 ? '↗' : '↘'} {Math.abs(stat.change)}%
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>
      )}

      {/* ===== NAVIGATION TABS ===== */}
      <nav className="tabs-navigation">
        <div className="tabs-container">
          <button
            className={`tab-btn ${activeTab === 'about' ? 'active' : ''}`}
            onClick={() => setActiveTab('about')}
          >
            <FaCube className="tab-icon" />
            <span>White Paper</span>
          </button>
          <button
            className={`tab-btn ${activeTab === 'usecases' ? 'active' : ''}`}
            onClick={() => setActiveTab('usecases')}
          >
            <FaLink className="tab-icon" />
            <span>Casos de Uso</span>
          </button>
          <button
            className={`tab-btn ${activeTab === 'tokenomics' ? 'active' : ''}`}
            onClick={() => setActiveTab('tokenomics')}
          >
            <FaCoins className="tab-icon" />
            <span>UtilityToken</span>
          </button>
          <button
            className={`tab-btn ${activeTab === 'charts' ? 'active' : ''}`}
            onClick={() => setActiveTab('charts')}
          >
            <FaChartLine className="tab-icon" />
            <span>Roadmap</span>
          </button>
        </div>
      </nav>

      {/* ===== CONTENT WRAPPER ===== */}
      <div className="content-wrapper">
        <main className="tokens-content">

          {/* ===== WHITE PAPER TAB CON CARRUSEL EN MÓVIL ===== */}
          {activeTab === 'about' && (
            <div className="tab-panel fade-in">
              <div className="section-header">
                <h2>White Paper</h2>
                <div className="header-line"></div>
              </div>

              {isMobile ? (
                // CARRUSEL WHITE PAPER EN MÓVIL
                <Swiper
                  modules={[Pagination, Autoplay]}
                  spaceBetween={16}
                  slidesPerView={1}
                  pagination={{ clickable: true }}
                  autoplay={{
                    delay: 4000,
                    disableOnInteraction: false
                  }}
                  loop={true}
                  className="wp-carousel"
                >
                  {wpCards.map((card, index) => (
                    <SwiperSlide key={index}>
                      <div className="wp-card-mobile">
                        <div className="wp-icon">{card.icon}</div>
                        <h3>{card.title}</h3>
                        {card.content && <p>{card.content}</p>}
                        {card.highlight && <p className="wp-highlight">{card.highlight}</p>}
                        {card.list && (
                          <ul className="wp-list">
                            {card.list.map((item, i) => (
                              <li key={i}>{item}</li>
                            ))}
                          </ul>
                        )}
                        {card.pillars && (
                          <div className="pillars-mini">
                            {card.pillars.map((pillar, i) => (
                              <div key={i} className="pillar-mini">
                                <span className="pillar-number">{i + 1}</span>
                                <span>{pillar}</span>
                              </div>
                            ))}
                          </div>
                        )}
                        {card.tech && (
                          <div className="tech-grid-mini">
                            {card.tech.map((item, i) => (
                              <div key={i} className="tech-item">
                                {i === 0 && <FaDatabase className="tech-icon" />}
                                {i === 1 && <FaCube className="tech-icon" />}
                                {i === 2 && <FaCodeBranch className="tech-icon" />}
                                {i === 3 && <FaMobile className="tech-icon" />}
                                <span>{item}</span>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              ) : (
                // GRID WHITE PAPER EN PC
                <div className="wp-grid">
                  {wpCards.map((card, index) => (
                    <div key={index} className={`wp-card ${card.title.toLowerCase().replace(' ', '-')}`}>
                      <div className="wp-icon">{card.icon}</div>
                      <h3>{card.title}</h3>
                      {card.content && <p>{card.content}</p>}
                      {card.highlight && <p className="wp-highlight">{card.highlight}</p>}
                      {card.list && (
                        <ul className="wp-list">
                          {card.list.map((item, i) => (
                            <li key={i}>{item}</li>
                          ))}
                        </ul>
                      )}
                      {card.pillars && (
                        <div className="pillars-mini">
                          {card.pillars.map((pillar, i) => (
                            <div key={i} className="pillar-mini">
                              <span className="pillar-number">{i + 1}</span>
                              <span>{pillar}</span>
                            </div>
                          ))}
                        </div>
                      )}
                      {card.tech && (
                        <div className="tech-grid-mini">
                          {card.tech.map((item, i) => (
                            <div key={i} className="tech-item">
                              {i === 0 && <FaDatabase className="tech-icon" />}
                              {i === 1 && <FaCube className="tech-icon" />}
                              {i === 2 && <FaCodeBranch className="tech-icon" />}
                              {i === 3 && <FaMobile className="tech-icon" />}
                              <span>{item}</span>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}

              {/* FEATURES SECTION CON CARRUSEL EN MÓVIL */}
              <div className="features-section">
                <h3 className="section-subtitle">Características Principales</h3>

                {isMobile ? (
                  // CARRUSEL FEATURES EN MÓVIL
                  <Swiper
                    modules={[Pagination, Autoplay]}
                    spaceBetween={16}
                    slidesPerView={1}
                    pagination={{ clickable: true }}
                    autoplay={{
                      delay: 3500,
                      disableOnInteraction: false
                    }}
                    loop={true}
                    className="features-carousel"
                  >
                    {features.map((feature, index) => (
                      <SwiperSlide key={index}>
                        <div className="feature-card-modern">
                          <div className="feature-icon-wrapper">{feature.icon}</div>
                          <h4>{feature.title}</h4>
                          <p>{feature.description}</p>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                ) : (
                  // GRID FEATURES EN PC
                  <div className="features-grid-modern">
                    {features.map((feature, index) => (
                      <div key={index} className="feature-card-modern">
                        <div className="feature-icon-wrapper">{feature.icon}</div>
                        <h4>{feature.title}</h4>
                        <p>{feature.description}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}

          {/* ===== CASOS DE USO TAB CON CARRUSEL EN MÓVIL ===== */}
          {activeTab === 'usecases' && (
            <div className="tab-panel fade-in">
              <div className="section-header">
                <h2>Casos de Uso</h2>
                <div className="header-line"></div>
              </div>

              {isMobile ? (
                // CARRUSEL CASOS DE USO EN MÓVIL (3 SLIDES)
                <Swiper
                  modules={[Pagination, Autoplay]}
                  spaceBetween={16}
                  slidesPerView={1}
                  pagination={{ clickable: true }}
                  autoplay={{
                    delay: 4000,
                    disableOnInteraction: false
                  }}
                  loop={true}
                  className="usecases-carousel"
                >
                  {useCases.map((uc, index) => (
                    <SwiperSlide key={index}>
                      <div className="usecase-modern-card">
                        <div className="usecase-number">{uc.number}</div>
                        <div className="usecase-icon-container">
                          {uc.icon}
                        </div>
                        <h3>{uc.title}</h3>
                        <p className="usecase-subtitle">{uc.subtitle}</p>
                        <div className="usecase-details">
                          <ul>
                            {uc.details.map((detail, i) => (
                              <li key={i}>{detail}</li>
                            ))}
                          </ul>
                          <div className="usecase-badge">
                            {uc.badge}
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              ) : (
                // GRID CASOS DE USO EN PC
                <div className="usecases-modern-grid">
                  {useCases.map((uc, index) => (
                    <div key={index} className={`usecase-modern-card ${index === 0 ? 'featured' : ''}`}>
                      <div className="usecase-number">{uc.number}</div>
                      <div className="usecase-icon-container">
                        {uc.icon}
                      </div>
                      <h3>{uc.title}</h3>
                      <p className="usecase-subtitle">{uc.subtitle}</p>
                      <div className="usecase-details">
                        <ul>
                          {uc.details.map((detail, i) => (
                            <li key={i}>{detail}</li>
                          ))}
                        </ul>
                        <div className="usecase-badge">
                          {uc.badge}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* ===== TOKENOMICS TAB (MEJORADO - DISTRIBUCIÓN MÁS ANCHA EN PC) ===== */}
          {activeTab === 'tokenomics' && (
            <div className="tab-panel fade-in">
              <div className="section-header">
                <h2>Tokenomics</h2>
                <div className="header-line"></div>
              </div>

              <div className="tokenomics-modern">
                <div className="supply-card">
                  <span className="supply-label">Suministro Total</span>
                  <span className="supply-value-large">21,000,000</span>
                  <span className="supply-symbol">BGP</span>
                </div>

                <div className="tokenomics-split-wide">
                  <div className="chart-card">
                    <div className="chart-container-modern" style={{ height: '320px' }}>
                      <Doughnut data={distributionData} options={chartOptions} />
                    </div>
                  </div>

                  <div className="distribution-card-wide">
                    <h4>Distribución</h4>
                    <div className="distribution-bars-wide">
                      <div className="dist-bar-item">
                        <div className="dist-bar-info">
                          <span className="dist-bar-label">
                            <span className="dist-dot sales"></span>
                            Ventas Públicas y Privadas
                          </span>
                          <span className="dist-bar-percentage">60%</span>
                        </div>
                        <div className="dist-bar-bg">
                          <div className="dist-bar-fill sales" style={{ width: '60%' }}></div>
                        </div>
                      </div>
                      <div className="dist-bar-item">
                        <div className="dist-bar-info">
                          <span className="dist-bar-label">
                            <span className="dist-dot team"></span>
                            Equipo y Fundadores
                          </span>
                          <span className="dist-bar-percentage">15%</span>
                        </div>
                        <div className="dist-bar-bg">
                          <div className="dist-bar-fill team" style={{ width: '15%' }}></div>
                        </div>
                      </div>
                      <div className="dist-bar-item">
                        <div className="dist-bar-info">
                          <span className="dist-bar-label">
                            <span className="dist-dot development"></span>
                            Desarrollo
                          </span>
                          <span className="dist-bar-percentage">10%</span>
                        </div>
                        <div className="dist-bar-bg">
                          <div className="dist-bar-fill development" style={{ width: '10%' }}></div>
                        </div>
                      </div>
                      <div className="dist-bar-item">
                        <div className="dist-bar-info">
                          <span className="dist-bar-label">
                            <span className="dist-dot marketing"></span>
                            Marketing y Adopción
                          </span>
                          <span className="dist-bar-percentage">10%</span>
                        </div>
                        <div className="dist-bar-bg">
                          <div className="dist-bar-fill marketing" style={{ width: '10%' }}></div>
                        </div>
                      </div>
                      <div className="dist-bar-item">
                        <div className="dist-bar-info">
                          <span className="dist-bar-label">
                            <span className="dist-dot reserve"></span>
                            Reserva Estratégica
                          </span>
                          <span className="dist-bar-percentage">5%</span>
                        </div>
                        <div className="dist-bar-bg">
                          <div className="dist-bar-fill reserve" style={{ width: '5%' }}></div>
                        </div>
                      </div>
                    </div>

                    <div className="mechanisms-card">
                      <h5>Mecanismos Adicionales</h5>
                      <div className="mechanisms-tags">
                        <span className="mechanism-tag">🔓 Liberación progresiva de tokens</span>
                        <span className="mechanism-tag">🔥 Sistema de quema ligado al uso</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* ===== ROADMAP TAB CON CARRUSEL EN MÓVIL ===== */}
          {activeTab === 'charts' && (
            <div className="tab-panel fade-in">
              <div className="section-header">
                <h2>Roadmap & Price</h2>
                <div className="header-line"></div>
              </div>

              <div className="roadmap-modern">
                <div className="chart-card-full">
                  <div className="chart-header">
                    <h4>Evolución del Precio BGP</h4>
                    <span className="chart-badge">+0.004% último año</span>
                  </div>
                  <div className="chart-container-full" style={{ height: '350px' }}>
                    <Line data={priceChartData} options={chartOptions} />
                  </div>
                </div>

                <div className="roadmap-timeline">
                  <h4>Roadmap Estratégico</h4>

                  {isMobile ? (
                    // CARRUSEL ROADMAP EN MÓVIL
                    <Swiper
                      modules={[Pagination, Autoplay]}
                      spaceBetween={16}
                      slidesPerView={1}
                      pagination={{ clickable: true }}
                      autoplay={{
                        delay: 3500,
                        disableOnInteraction: false
                      }}
                      loop={true}
                      className="roadmap-carousel"
                    >
                      {roadmapPhases.map((phase, index) => (
                        <SwiperSlide key={index}>
                          <div className={`timeline-card phase${index + 1}`}>
                            <div className="timeline-marker">{phase.phase}</div>
                            <div className="timeline-content">
                              <h5>{phase.title}</h5>
                              <ul>
                                {phase.items.map((item, i) => (
                                  <li key={i} className={item.status}>
                                    {item.status === 'completed' ? '✓' : item.status === 'in-progress' ? '⚡' : '○'} {item.text}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  ) : (
                    // GRID ROADMAP EN PC
                    <div className="timeline-grid">
                      {roadmapPhases.map((phase, index) => (
                        <div key={index} className={`timeline-card phase${index + 1}`}>
                          <div className="timeline-marker">{phase.phase}</div>
                          <div className="timeline-content">
                            <h5>{phase.title}</h5>
                            <ul>
                              {phase.items.map((item, i) => (
                                <li key={i} className={item.status}>
                                  {item.status === 'completed' ? '✓' : item.status === 'in-progress' ? '⚡' : '○'} {item.text}
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </main>
      </div>

    </div>
  );
};

export default TokensPage;